import { render, staticRenderFns } from "./Class.vue?vue&type=template&id=71b4128a&scoped=true"
import script from "./Class.vue?vue&type=script&lang=js"
export * from "./Class.vue?vue&type=script&lang=js"
import style0 from "./Class.vue?vue&type=style&index=0&id=71b4128a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4128a",
  null
  
)

export default component.exports